import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-offer-modify',
  templateUrl: './offer-modify.component.html',
  styleUrls: ['./offer-modify.component.css']
})
export class OfferModifyComponent implements OnInit {

  OfferData: any = []
  cid:any
  editForm: any | FormGroup
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  offerid: any = "";
  editFormSubmitted = false;
  addButton = false;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllOffer()
    this.editForm = this.fb.group({
      name: ['',[Validators.required]],
      description: ['',[Validators.required]],
    })
  }


  updateOffer(){
    this.editFormSubmitted = true;
    if(!this.editForm.valid){
      console.log(this.editForm.value)
      return
    }
    this.addButton = true;
    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.editForm.get('description').value),
      "id": this.offerid,
      "name": String(this.editForm.get('name').value),
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.updateOffer(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getAllOffer()
        this.cancelModel()
        this.editForm.reset()
        this.editFormSubmitted = false;
        this.addButton = false;
        this.toastr.success("Successfully Updated")
      },
      (error:any)=>{
        console.log(error)
        this.addButton = false;
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllOffer();
  }

  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllOffer();
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllOffer(){
    this.generic_service.getAllOffer().subscribe(
      (res:any)=> {
        console.log(res)
        this.OfferData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getOfferById(id:any){
    this.offerid = id
    this.generic_service.getOfferById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.editForm.patchValue({
          name: response.response.name,
          description: response.response.description,
        })
        console.log(this.editForm.value)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

}